"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = __importDefault(require("lodash"));
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const react_use_1 = require("react-use");
const access_1 = require("../../../../../common/constants/access");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const StyledMenuItem_1 = require("../../../../material-ui-theme/components/styled/StyledMenuItem");
const query_keys_1 = require("../../../../queries/query-keys");
const requestListQuery_1 = require("../../../../queries/requestListQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const Root_1 = require("../../../../router/Root");
const zustandStore_1 = require("../../../../zustandStore");
const logger = (0, pino_1.default)();
const CreateNewRequestButton = () => {
    const isOpenOnDesktopView = (0, zustandStore_1.useZustand)(state => state.sideMenu.isOpenOnDesktopView ?? true);
    const isOpenOnMobileView = (0, zustandStore_1.useZustand)(state => state.sideMenu.isOpenOnMobileView ?? false);
    const { openSideMenuOnMobileView, setPageLoading } = (0, zustandStore_1.useZustand)();
    const theme = (0, material_1.useTheme)();
    const { data: requests, isFetching: isGetRequestsFetching } = (0, requestListQuery_1.useGetRequestListQuery)();
    const { data: teamId } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const registerRequest = (0, requestListQuery_1.useRegisterRequestMutation)();
    const navigate = (0, react_router_1.useNavigate)();
    const { data: isCompanySettingsVisible, isLoading: isLoadingIsCompanySettingsVisible, isError: isVerifyAccessError, } = (0, userQuery_1.useGetVerifyUserAccess)(access_1.composites.WRITE_COMPANY);
    const isMobileWidth = (0, react_use_1.useMedia)('(max-width: 650px)');
    const [isNewRequestLoading, setIsNewRequestLoading] = (0, react_1.useState)(false);
    /**
     * Supplies a new request id and navigates to request creation page
     */
    const createRequest = async (e) => {
        e?.preventDefault();
        setIsLoading(true);
        if (isNewRequestLoading || isGetRequestsFetching) {
            setIsLoading(false);
            return;
        }
        setIsNewRequestLoading(true);
        if (isMobileWidth) {
            openSideMenuOnMobileView(false);
        }
        const createdRequest = Array.isArray(requests)
            ? requests.find(request => {
                if (teamId?.[0]) {
                    return request.state === appConstants_1.requestStatus.CREATED && request.teamId === teamId?.[0];
                }
                return request.state === appConstants_1.requestStatus.CREATED;
            })
            : { requestId: '' };
        if (!lodash_1.default.isEmpty(createdRequest) && createdRequest.requestId) {
            void navigate(`/requests/${createdRequest.requestId}`);
            setIsNewRequestLoading(false);
            setIsLoading(false);
            setPageLoading(false);
        }
        else {
            const requestId = crypto.randomUUID();
            registerRequest.mutate({ requestId }, {
                onSuccess: () => {
                    void navigate(`/requests/${requestId}`);
                },
                onError: error => {
                    logger.error(error);
                    void navigate('/error');
                },
                onSettled: async () => {
                    setIsLoading(false);
                    setPageLoading(false);
                    setIsNewRequestLoading(false);
                    await Root_1.queryClient.invalidateQueries({
                        queryKey: query_keys_1.requestKeys.getRequestList(),
                    });
                },
            });
        }
    };
    if (isVerifyAccessError) {
        return null;
    }
    return !isCompanySettingsVisible && !isLoadingIsCompanySettingsVisible ? ((0, jsx_runtime_1.jsx)(StyledMenuItem_1.StyledMenuItem, { style: {
            marginTop: theme.tsGoUnit.tsUnit,
            justifyContent: `${isMobileWidth ? 'flex-start' : 'center'}`,
        }, children: (0, jsx_runtime_1.jsx)(material_1.Button, { "data-testid": "sideMenu-createRequest-btn", id: "sideMenu-createRequest-btn", color: uiConstants_1.UI_BUTTON_PRIMARY, type: "submit", loading: isLoading, variant: "contained", onClick: createRequest, style: {
                fontSize: theme.typography.tsFontSize.default,
                width: isOpenOnMobileView && isMobileWidth ? '100%' : 'initial',
                padding: isOpenOnDesktopView || (isOpenOnMobileView && isMobileWidth)
                    ? globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                        ? '8px 37px'
                        : '8px 85px'
                    : '8px',
                minWidth: isOpenOnDesktopView || (isOpenOnMobileView && isMobileWidth) ? 'initial' : 'auto',
            }, children: isOpenOnDesktopView || (isOpenOnMobileView && isMobileWidth) ? (strings_1.sideMenuStrings.SIDE_MENU_CREATE_NEW_REQUEST_BUTTON) : ((0, jsx_runtime_1.jsx)(Add_1.default, {})) }) })) : null;
};
exports.default = CreateNewRequestButton;
